<div class="shell-root">
  <div class="popup-row top-row program-menu-bar">
    <button mat-button [matMenuTriggerFor]="fileMenu">File</button>
    <button mat-button [matMenuTriggerFor]="actionsMenu">Actions</button>
    <button mat-button [matMenuTriggerFor]="logsMenu">Logs</button>
    <button mat-button [matMenuTriggerFor]="dangerMenu" color="warn">Danger zone</button>
    <mat-menu #fileMenu="matMenu">
      <button mat-menu-item (click)="connectUsingIP()">Connect ({{systemIP}})</button>
      <button mat-menu-item (click)="connectUsingNumber()">Connect ({{systemNumberIp}})</button>
      <hr />
      <button mat-menu-item (click)="copyText()">Copy selected</button>
      <button mat-menu-item (click)="pasteText()">Paste</button>

      <hr />
      <button mat-menu-item (click)="exportTerminalToTextFile()">Save terminal output</button>
    </mat-menu>
    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item (click)="restartContainer()">Restart program</button>
    </mat-menu>
    <mat-menu #logsMenu="matMenu">
      <button mat-menu-item (click)="startLiveLog()">Live log</button>
      <button mat-menu-item *ngIf="terminalAdmin" (click)="toggleAutoStartLog()"
        [ngClass]="{'active': autoStartLog, 'inactive': !autoStartLog}">Auto start log ({{autoStartLog ? 'ON' :
        'OFF'}})</button>
      <hr />
      <button mat-menu-item [matMenuTriggerFor]="watchLogsMenu">Watch logs</button>
      <button mat-menu-item [matMenuTriggerFor]="downloadLogsMenu">Download logs</button>
    </mat-menu>
    <mat-menu #watchLogsMenu="matMenu">
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/logs')">Normal log</button>
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/verbose')">Verbose log</button>
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/debug')">Debug log</button>
      <hr />
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/jsd_logs')">JSD log</button>
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/cellular')">Cellular</button>
      <button mat-menu-item (click)="watchLatestFile('/home/hh/system/logs/temperature')">Temperature</button>
    </mat-menu>
    <mat-menu #downloadLogsMenu="matMenu">
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/logs')">Normal log</button>
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/verbose')">Verbose log</button>
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/debug')">Debug log</button>
      <hr />
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/jsd_logs')">JSD log</button>
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/cellular')">Cellular</button>
      <button mat-menu-item (click)="requestFileDownload('/home/hh/system/logs/temperature')">Temperature</button>
    </mat-menu>
    <mat-menu #dangerMenu="matMenu">
      <button mat-menu-item (click)="restartComputer()">Restart Computer</button>
      <hr />
      <button mat-menu-item (click)="updateSoftware()">Update software</button>
      <button mat-menu-item [matMenuTriggerFor]="dockerMenu">Docker compose</button>
      <hr />
      <button mat-menu-item (click)="openFileUploadDialog()">Upload file</button>
      <button mat-menu-item (click)="openFileDownloadDialog()">Download file</button>
    </mat-menu>
    <mat-menu #dockerMenu="matMenu">
      <button mat-menu-item (click)="pullContainer()">Pull container</button>
      <button mat-menu-item (click)="dockerComposeUp()">Docker compose up</button>
      <button mat-menu-item (click)="dockerComposeDown()">Docker compose down</button>
      <button mat-menu-item (click)="openComposeFile()">Open compose file</button>
    </mat-menu>
    <!-- <div *ngIf="systemIP" class="copy-ssh-command" (click)="copyToClipboard('ssh -p 5932 hh@' + systemIP)">Copy SSH
      Command</div> -->
           <mat-menu #sshMenu="matMenu">
      <button mat-menu-item (click)="copyToClipboard('ssh -p 5932 hh@' + systemIP)">ssh -p 5932 hh{{ '@' + systemIP }}</button>
      <button mat-menu-item (click)="copyToClipboard('ssh -L 80:192.168.1.1:80 -p 5932 hh@' + systemIP)">ssh -L 80:{{ systemIP }}:80 -p 5932 hh{{ '@' + systemIP }}</button>
      <button mat-menu-item (click)="copyToClipboard('ssh -L 443:192.168.1.1:443 -p 5932 hh@' + systemIP)">
        ssh -L 443:{{ systemIP }}:443 -p 5932 hh{{ '@' + systemIP }}
      </button> 
    </mat-menu>
    <div *ngIf="systemIP" [matMenuTriggerFor]="sshMenu" class="ip-text">{{ systemIP }}</div>
    <div *ngIf="systemIP" class="ip-text">v{{ version }} ({{ releaseDate }})</div>
    <div *ngIf="systemIP" class="ip-text">{{ jsdVersion }}</div>
  </div>
  <div class="full-height-flex">
    <div mat-dialog-actions class="terminal-actions">
      <ng-terminal #ngTerm (contextmenu)="onContextMenu($event)" class="terminal-full"></ng-terminal>
    </div>
  </div>
</div>